import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 激活码状态枚举
 */
class State extends UltMeta {
    UNUSED = new Meta(1, "未使用");
    USED = new Meta(2, "已使用");
    OVERDUE = new Meta(3, "过期");
}

export const STATE = new State();
/**
 * 是否绑定
 */
class HasBind extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}

export const HAS_BIND = new HasBind();
/**
 * 错误码
 */
class ErrorMessage extends UltMeta {
    REDEMPTION_SUCCESS = new Meta(1, "兑换成功");
    REDEMPTION_FAILED = new Meta(2, "兑换失败");
    ACTIVATION_CODE_INVALID = new Meta(3, "激活码无效");
    ACTIVATION_FAILED = new Meta(4, "激活失败");
    REDEMPTION_CLOSED = new Meta(5, "兑换关闭");
}
export const ERROR_MESSAGE = new ErrorMessage();
